//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      darkMode: false,
    }
  },
  mounted() {
    if (this.$isDarkMode) {
      this.toggleDarkMode(null, true)
    }
  },
  methods: {
    toggleDarkMode(e, val) {
      e && e.preventDefault()
      this.darkMode = val || !this.darkMode
      document.documentElement.classList[this.darkMode ? 'add' : 'remove'](
        'dark'
      )
      document.cookie = `darkMode=${this.darkMode}; Secure; max-age=31536000; path=/;`
      document.documentElement.classList.remove('hidden')
    },
  },
}
